import { render, staticRenderFns } from "./EdiData.vue?vue&type=template&id=97617ba8&"
import script from "./EdiData.vue?vue&type=script&lang=js&"
export * from "./EdiData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports